<template>
  <FlexBox
    direction="row"
    alignment="center"
    class="pb-dialog-actions"
  >
    <ControlButton
      v-focus="focusCancel"
      v-bind="cancelAttrs"
      class="pb-dialog-actions-button pb-dialog-actions-cancel-button"
      :class="cancelStyle ? `btn-${cancelStyle}` : null"
      :label="translate(cancelText)"
      :disabled="!enabled || cancelDisabled"
      @click.prevent="cancel"
    />
    <ControlButton
      v-focus="focusConfirm"
      v-bind="confirmAttrs"
      class="pb-dialog-actions-button pb-dialog-actions-confirm-button"
      :class="confirmStyle ? `btn-${confirmStyle}` : null"
      :label="translate(confirmText)"
      :is-loading="loading"
      :disabled="!enabled || confirmDisabled"
      @click.prevent="confirm"
    />
  </FlexBox>
</template>

<script setup>
import { computed } from 'vue'
import ControlButton from '@nicolaudie-group/ng-ui-kit/components/ControlButton/ControlButton.vue'
import FlexBox from '@nicolaudie-group/ng-ui-kit/components/FlexBox/FlexBox.vue'
import vFocus from '@nicolaudie-group/ng-ui-kit/directives/vFocus'
import useTranslate from '@/composables/useTranslate'

const props = defineProps({
  loading: { type: Boolean, default: false },
  cancelText: { type: String, default: 'pb2.dialogActions.defaultCancelLabel' },
  confirmText: { type: String, default: 'pb2.dialogActions.defaultConfirmLabel' },
  focusCancel: { type: Boolean, default: false },
  focusConfirm: { type: Boolean, default: true },
  cancelStyle: { type: String, default: '' },
  confirmStyle: { type: String, default: 'success' },
  cancelDisabled: { type: Boolean, default: false },
  confirmDisabled: { type: Boolean, default: false },
  cancelAttrs: { type: Object, default: () => ({}) },
  confirmAttrs: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['close', 'confirm', 'cancel'])

const { translate } = useTranslate()

const enabled = computed(() => !props.loading)

function cancel(...args) {
  if (enabled.value) {
    return emit('cancel', ...args)
  }
  return undefined
}

function confirm(...args) {
  if (enabled.value) {
    return emit('confirm', ...args)
  }
  return undefined
}
</script>

<style lang="scss">
@use 'sass:math';
@use '@nicolaudie-group/ng-ui-kit/defines/_fonts.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_colors.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_config.define.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_flexbox.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_generic.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_responsive.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_theme.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_animations.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_transitions.mixin.scss';

@use '/src/styles/_pb.scss';

.pb-dialog-actions {
  max-width: 400px;
  margin: auto;
}

.pb-dialog-actions-button {
  margin: 0 10px;
  @include flexbox.flex-grow(1);
}
</style>
